import { render, staticRenderFns } from "./AdvancedSettingsWrapper.vue?vue&type=template&id=4206abbf&lang=pug&"
import script from "./AdvancedSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports